import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchCompanyMeetings = createAsyncThunk("fetchCompanyMeetings", async ({ page, limit, startDateTime, duration }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const params = new URLSearchParams({
		page: String(page),
		limit: String(limit),
		startDateTime: startDateTime,
		duration: String(duration),
	});

	const response = await axiosHttp.get(`meeting/company/meetinglist?${params}`, config);
	return response.data.data;
});

const CompanyMeetingListSlice = createSlice({
	name: "CompanyMeetingListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchCompanyMeetings.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchCompanyMeetings.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchCompanyMeetings.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default CompanyMeetingListSlice.reducer;
